import { Map } from 'immutable';
import { stringify } from 'query-string';

import Api from '../api';

import Picture from './model';
import { addAction, addMultipleAction, updateAction, removeAction } from './actions';

export default class PicturesApi {
  static fetchAll(categories: string[] = []) {
    return Api.get(
      `api/pictures?${categories?.length ? stringify({ categories: categories.join(',') }) : ''}`
    ).map((pictures) =>
      addMultipleAction(Map(pictures.map((picture) => [picture.id, new Picture(picture)])))
    );
  }

  static fetch(id) {
    return Api.get(`api/pictures/${id}`).map((picture) => addAction(new Picture(picture)));
  }

  static create(data) {
    return Api.post('api/pictures', data).map((picture) => addAction(new Picture(picture)));
  }

  static update(id, data) {
    return Api.patch(`api/pictures/${id}`, data).map((picture) =>
      updateAction(new Picture(picture))
    );
  }

  static delete(id) {
    return Api.delete(`api/pictures/${id}`).map(() => removeAction(id));
  }
}
